export default __webpack_public_path__ + "static/media/wormhole.a69fe756.gif";